import styled from "styled-components";

const GoalSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;

  width: 100vw;

  position: absolute;
  top: 45px;
`;
export default GoalSc;
